/**
 * Константы для авторизации
 * 
 * V2 система (для обычных пользователей):
 * - Access token в cookies (БЕЗ maxAge - живет до закрытия браузера)
 * - Истечение проверяется через timestamp в tokenExpiryTimes
 * - Refresh token в HttpOnly cookies (управляется сервером, не доступен на фронте)
 * - Session ID в sessionStorage
 * 
 * V1 система (для админов):
 * - Access token в cookies (БЕЗ maxAge - живет до закрытия браузера)
 * - Истечение проверяется через timestamp в tokenExpiryTimes
 * - Refresh token в cookies (30 дней)
 */

// === V2 СИСТЕМА (Обычные пользователи) ===

// Время жизни access token в секундах (5 минут)
// ✅ ВАЖНО: Это НЕ maxAge cookies, а срок для проверки истечения через timestamp
// ✅ Токен НЕ удаляется из cookies автоматически - только обновляется при истечении
export const ACCESS_TOKEN_MAX_AGE_SECONDS = 60 * 5 // 300 секунд

// Время жизни сессии в секундах (30 дней)
export const SESSION_MAX_AGE_SECONDS = 60 * 60 * 24 * 30 // 2592000 секунд

// === V1 СИСТЕМА (Только для админов) ===

// Время жизни админского access token в секундах (5 минут)
// ✅ ВАЖНО: Это НЕ maxAge cookies, а срок для проверки истечения через timestamp
// ✅ Токен НЕ удаляется из cookies автоматически - только обновляется при истечении
export const ADMIN_ACCESS_TOKEN_MAX_AGE_SECONDS = 60 * 5 // 300 секунд

// Время жизни админского refresh token в секундах (30 дней)
// ✅ Refresh token С maxAge - долгоживущий, может удаляться автоматически браузером
export const ADMIN_REFRESH_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 24 * 30 // 2592000 секунд